module.exports = __webpack_public_path__ + "static/agroforestry-263a30e637701201278f2086af2e74d2.svg";